import { SelectAsync } from '@core/components/Select';
import financeiroApi from 'app/services/api/financeiroApi';
import React from 'react';

const fetchByValue = async (id, idObject, api, value, setSelected, handleChange) => {
  const response = await financeiroApi.get(`${api}/${value}?sigla=${value}`);
  if (response.status === 200) {
    handleChange({ target: { id: idObject, value: response.data } });
    setSelected(response.data);
  }
};

const SelectUnidadeFederativa = ({
  id,
  idObject = 'pessoa.endereco.uf',
  handleChange,
  value,
  readOnly,
  disabled,
  handleBlur,
  error,
  touched,
  label,
  helperText,
  required,
}) => {
  return (
    <SelectAsync
      id={id}
      label={label || 'UF'}
      required={required}
      api="/api/v1/backend/uf"
      name="nome"
      handleChange={handleChange}
      handleBlur={handleBlur}
      error={error}
      touched={touched}
      value={value}
      helperText={helperText}
      readOnly={readOnly}
      disabled={disabled}
      idObject={idObject}
      fetchByValue={fetchByValue}
    />
  );
};

export default SelectUnidadeFederativa;
